<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Name</label>
                <input type="text" class="form-control" id="customer-name" v-model="ct.name">
            </div>
        </div>
        <div class="row">
          <app-lookup-field :model="ct" :element="customerTypeLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../services/api'
import { customer } from '../models/customer'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
  components: {
    AppLookupField, AppDatePicker, AppNavBar, AppLookupField
  },
  data() {
    return {
      ct: {...customer},
      customerTypeLookup: {
        id: 'customer-type',
        title: 'Customer Type',
        type: 'form',
        apiUrl: 'customer-type-list',
        filter: ['name'],
        fields: [
            {
              placeholder: 'Customer Type',
              width: 4,
              column: 'customerType'
            }
        ],
        dtElements: [
            {
              title: 'Nama',
              column: 'name'
            },
        ],
        affectedField: [
          {
            from: 'id',
            to: 'customerTypeId'
          },
          {
            from: 'name',
            to: 'customerType'
          }
        ]
      },
    }
  },
  async created() {
      if(this.$route.query.id !== undefined) {
          const ctApi = api('customer')
          this.ct = await ctApi.getWithParams(this.$route.query.id)
      }
  },
  methods: {
    async save() {
      const ctApi = api('customer')
      if(this.$route.query.id !== undefined) {
        await ctApi.update(this.ct, this.$route.query.id)
      } else {
        await ctApi.create(this.ct)
      }
      this.$router.go(-1)
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentCt = this.ct
      this.ct = {
        ...currentCt,
        ...data
      }
    }
  }
}
</script>